module.exports = __webpack_public_path__ + "static/media/contato.35af5197.png";